import type { PayloadAction } from '@reduxjs/toolkit';

import { offerStatusToLoansStatusAdapter } from 'shared/lib';
import type { TOffer, TProductsResponse } from 'shared/types/TRankingService';

import type { ScenarioState } from 'entities/scenario';

import { isMplPreApprovalOfferElement, updateOnlineGroupElements } from '../../lib';
import { selectOnlineGroup } from '../creditSelection.selectors';

export const setMplOfferStatusesFromRankingOffers = (
  state: ScenarioState,
  action: PayloadAction<TProductsResponse>,
) => {
  const onlineGroup = selectOnlineGroup({ scenario: state });

  if (!onlineGroup || !onlineGroup.elements) {
    return;
  }

  const { offers } = action.payload;

  const statusByProductId = new Map<string, TOffer['status']>();
  const statusByBankId = new Map<string, TOffer['status']>();

  offers.forEach((offer) => {
    if (offer.status && offer.status !== 'new') {
      statusByProductId.set(offer.id, offer.status);
      statusByBankId.set(offer.bankId, offer.status);
    }
  });

  const elements = onlineGroup.elements.map((offer) => {
    if (!isMplPreApprovalOfferElement(offer)) {
      return offer;
    }

    const statusById = statusByProductId.get(offer.productId);

    if (statusById) {
      return {
        ...offer,
        apiStatus: offerStatusToLoansStatusAdapter(statusById),
      };
    }

    if (statusByBankId.has(offer.organizationNewId)) {
      return {
        ...offer,
        isAlreadySentFromSameBank: true,
      };
    }
    return offer;
  });

  updateOnlineGroupElements(state, elements);
};
